import React, { useEffect, useState } from 'react'
import { css } from '@emotion/core'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { DiscoveryWheelchair } from '@fs/zion-icon'
import { IconButton } from '@fs/zion-ui'
import { trackEvent } from '@fs/zion-analytics'

const accessCss = css`
  position: fixed;
  bottom: 80px;
  inset-inline-end: 40px;
  cursor: pointer;
  border: none;
  background: none;
  z-index: 2;
`

const usePullDown = ({ access, pullDown, pull }) => {
  const pullPixel = pull ? `${pull}px` : '500px'
  useEffect(() => {
    const main = document.getElementById('root')
    if (pullDown) {
      main.style.transition = 'margin-top 0.5s ease-in'
      main.style.marginTop = access ? pullPixel : '0'
    } else {
      main.removeAttribute('style')
    }
  }, [pullPixel, pullDown, access])
}

const Accessibility = ({ children, onClick, pullDown, pull, isAccessible = false }) => {
  const [t] = useTranslation()
  const [access, setIsAccessible] = useState(isAccessible)
  usePullDown({ access, pullDown, pull })
  const toggle = () => setIsAccessible((val) => !val)

  return (
    <>
      <div css={accessCss}>
        <IconButton
          data-testid="accessibility-move-controls-button"
          aria-label={t(
            'a11y.accessbility-button.label',
            'Accessibility: click to move controls to a more suitable position.'
          )}
          role="switch"
          aria-checked={access}
          Icon={DiscoveryWheelchair}
          size="xl"
          emphasis={access ? 'high' : 'medium'}
          linkName="Accessibility:WHEELCHAIR_TOGGLE_BUTTON:CLICK"
          onClick={() => {
            toggle()
            trackEvent({ event_name: 'WCF_Accessibility:ACCESSIBLE_BUTTON:CLICK', value: !access ? 'on' : 'off' })
            onClick?.(access)
          }}
        />
      </div>
      {children}
    </>
  )
}

Accessibility.propTypes = {
  children: PropTypes.shape({}),
}

export default Accessibility
